import { useCallback, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import useCreateOrder from './useCreateOrder';
import { useGiftCardState } from '@root/state';
import usePayMethod from '../usePayMethod';

const useGiftCardPayMethod = () => {
  const navigate = useNavigate();
  const payMethodState = usePayMethod();
  const { paying, onCreateGiftCardExtensionOrder } = useCreateOrder();
  const { packageId } = useParams();
  const selectedPackage = useGiftCardState(
    (state) => state.selectExtendPackage,
  );
  const { payMethod } = payMethodState;

  const onClickPay = useCallback(() => {
    if (!selectedPackage) {
      navigate(-1);
      return;
    }

    onCreateGiftCardExtensionOrder(selectedPackage, payMethod);
  }, [navigate, onCreateGiftCardExtensionOrder, payMethod, selectedPackage]);

  useEffect(() => {
    if (selectedPackage?.packageId !== packageId) {
      navigate(-1);
    }
  }, [navigate, packageId, selectedPackage]);

  return {
    state: {
      paying,
      payMethodState,
    },
    action: {
      onClickPay,
    },
  };
};

export default useGiftCardPayMethod;
